import { render, staticRenderFns } from "./AgregarImagen.vue?vue&type=template&id=215640ad"
import script from "./AgregarImagen.vue?vue&type=script&lang=js"
export * from "./AgregarImagen.vue?vue&type=script&lang=js"
import style0 from "./AgregarImagen.vue?vue&type=style&index=0&id=215640ad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports